<router-outlet outlet="outletExternal"></router-outlet>
<app-kv-toast></app-kv-toast>
<kv-spinner-loading></kv-spinner-loading>
<p-confirmDialog width="425" id="confirm"></p-confirmDialog>



// WEBPACK FOOTER //
// ./src/app/app.component.html